export default __webpack_public_path__ + "static/media/specialist@3x.68e1af9a.png";